<template>
  <div :class="$style.skeleton" test-id="file-preview-skeleton">
    <div v-if="toolbar" :class="$style.toolbar">
      <SCASkeletonItem width="40%" height="var(--size-2xSmall)" />
      <div :class="$style.buttons">
        <SCASkeletonItem v-for="i in 4" :key="i" width="var(--size-small)" height="var(--size-small)" />
      </div>
    </div>
    <SCASkeletonItem :class="$style.content" width="100%" height="100%" />
  </div>
</template>

<script setup lang="ts">
import { SCASkeletonItem } from "@scayla/components";

withDefaults(
  defineProps<{
    /** Off where the preview's real toolbar is already shown above the skeleton. */
    toolbar?: boolean;
  }>(),
  { toolbar: true },
);
</script>

<style lang="scss" module>
// Covers the closest positioned ancestor, so a file can load underneath it.
.skeleton {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-component-gap-small);
  box-sizing: border-box;
  padding: var(--space-component-padding-medium);
  background: var(--color-background-default);
}

.toolbar {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-component-gap-small);
  height: var(--dimension-550);
}

.buttons {
  display: flex;
  gap: var(--space-component-gap-small);
}

.content {
  flex: 1 1 auto;
  min-height: 0;
}
</style>
